/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Value } from './Value';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
    ValueToJSONTyped,
} from './Value';
import type { Link } from './Link';
import {
    LinkFromJSON,
    LinkFromJSONTyped,
    LinkToJSON,
    LinkToJSONTyped,
} from './Link';

/**
 * A consignment detail provides information about a specific customer order line and the quantity of products to be delivered.  The physical product items can be defined beforehand or during a preparation process. The pieces containing the items are typically identified after the goods are prepared. If the pieces cannot be identified, BatchOfGoods (groups of pieces per products) should be defined in the services.
 * @export
 * @interface ConsignmentDetail
 */
export interface ConsignmentDetail {
    /**
     * Customer order line delivered through the consignment.
     * @type {string}
     * @memberof ConsignmentDetail
     */
    customerOrderLineId?: string;
    /**
     * 
     * @type {Link}
     * @memberof ConsignmentDetail
     */
    customerOrder?: Link;
    /**
     * This refers to the physical items that are included in the consignment to deliver the products that were ordered by the customer in the customer order line.
     * @type {Array<Link>}
     * @memberof ConsignmentDetail
     */
    items?: Array<Link>;
    /**
     * The smallest logistic unit used to carry the items from the origin location to the final location, which cannot be split along the supply chain.
     * @type {Array<Link>}
     * @memberof ConsignmentDetail
     */
    pieces?: Array<Link>;
    /**
     * Any decimal amount with any unit.
     * @type {Value}
     * @memberof ConsignmentDetail
     */
    quantity?: Value;
}

/**
 * Check if a given object implements the ConsignmentDetail interface.
 */
export function instanceOfConsignmentDetail(value: object): value is ConsignmentDetail {
    return true;
}

export function ConsignmentDetailFromJSON(json: any): ConsignmentDetail {
    return ConsignmentDetailFromJSONTyped(json, false);
}

export function ConsignmentDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsignmentDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'customerOrderLineId': json['customerOrderLineId'] == null ? undefined : json['customerOrderLineId'],
        'customerOrder': json['customerOrder'] == null ? undefined : LinkFromJSON(json['customerOrder']),
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(LinkFromJSON)),
        'pieces': json['pieces'] == null ? undefined : ((json['pieces'] as Array<any>).map(LinkFromJSON)),
        'quantity': json['quantity'] == null ? undefined : ValueFromJSON(json['quantity']),
    };
}

export function ConsignmentDetailToJSON(json: any): ConsignmentDetail {
    return ConsignmentDetailToJSONTyped(json, false);
}

export function ConsignmentDetailToJSONTyped(value?: ConsignmentDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customerOrderLineId': value['customerOrderLineId'],
        'customerOrder': LinkToJSON(value['customerOrder']),
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(LinkToJSON)),
        'pieces': value['pieces'] == null ? undefined : ((value['pieces'] as Array<any>).map(LinkToJSON)),
        'quantity': ValueToJSON(value['quantity']),
    };
}

